// Calls to the server functions (Mumbai). Errors come back with a short code in the message
// (e.g. EMAIL_REQUIRED, EXISTS) that screens turn into friendly text.
import { httpsCallable } from 'firebase/functions';
import { fns } from '../lib/firebase';

export async function callServer<T = unknown>(name: string, data: object): Promise<T> {
  if (!fns) throw new Error('Server not configured');
  try {
    const res = await httpsCallable(fns, name)(data);
    return res.data as T;
  } catch (e) {
    const msg = e instanceof Error ? e.message : '';
    throw new Error(['EMAIL_REQUIRED', 'EXISTS', 'TOO_SHORT', 'NEEDS_LETTER_AND_NUMBER', 'USED', 'EXPIRED', 'INVALID', 'ALREADY_ACCEPTED', 'INACTIVE', 'NOT_ON_TEST_LIST', 'TEST_MODE_ONLY', 'NO_TEST_MOTHER', 'NO_DRAFT', 'WRONG_KIND', 'BAD_PHONE', 'NO_SCHEDULE', 'IDENTITY_NOT_CHECKED', 'TOO_MANY', 'NOT_ALLOWED', 'NO_USER', 'REASON_REQUIRED', 'CODE_EXPIRED', 'CODE_TOO_MANY', 'CODE_WRONG', 'CODE_NONE', 'EMAIL_FAILED'].includes(msg) ? msg : msg || 'SERVER_ERROR');
  }
}
